/*

*/
import React from 'react'

const ErrorValidationIcon = (props) => {
    const { name = "", size = "s", color = '#fff', className = "" } = props;

    return (
        <svg className={('icon', name) + " " + className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9.99999 18.3334C14.5833 18.3334 18.3333 14.5834 18.3333 10C18.3333 5.41669 14.5833 1.66669 9.99999 1.66669C5.41666 1.66669 1.66666 5.41669 1.66666 10C1.66666 14.5834 5.41666 18.3334 9.99999 18.3334Z" stroke="#FF5A55" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 6.66669V10.8334" stroke="#FF5A55" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.99542 13.3333H10.0029" stroke="#FF5A55" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
};

export default ErrorValidationIcon
